const routes = [
  {
    path: '/project-settings',
    name: 'project-settings',
    component: () => import('./views/ProjectSettings/index.vue'),
    meta: {
      title: 'Настройки проекта',
      accessList: ['admin'],
    },
  },
];

export default routes;
